module.exports = __webpack_public_path__ + "img/3-2.ff66cef.png";